<template>
  <Card
    :is-full-height="isFullHeight"
  >
    <template #body>
      <ImageView
        :image="image"
        :image-type="imageType"
        :is-favorites="isFavorites"
        :large="true"
        :location="location"
        @show-image="$emit('show-image')"
        @show-video="$emit('show-video')"
      />
    </template>
  </Card>
</template>

<script>
export default {
  name: 'ImageViewCard',

  props: {
    image: {
      type: Object,
      required: true,
    },
    imageType: {
      type: String,
      required: true,
    },
    isFavorites: {
      type: Boolean,
      default: false,
    },
    isFullHeight: {
      type: Boolean,
      default: false,
    },
    location: {
      type: Object,
      required: true,
    },
  },

  emits: ['show-image', 'show-video'],
};
</script>
